module.exports = __webpack_public_path__ + "img/DiHS_Dashboard_Icon_Uhr_Layer.de47bbec.jpg";